export const HeaderButtonComponent = ({text, url}) => {
    return <div className="flex items-center text-gray-800 font-bold ml-4 cursor-pointer">
        <a href={url} className="border-transparent border-b-4 hover:border-primary">
            {text}
        </a>
    </div>;
}